<template>
  <div>
    <v-row>
      <v-col
        cols="3"
        class="max-width-3 min-width-3"
        style="box-sizing: content-box"
      >
        <strong>アバター</strong>
        <v-img
          :src="
            checkStatusAvatar
              ? profileTeacher.infoConfirm.avatar.data
              : profileTeacher.avatar
              ? profileTeacher.avatar
              : imageNotFound
          "
          max-height="300"
          min-width="300"
          max-width="300"
          aspect-ratio="1.4"
        >
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular
                indeterminate
                color="primary"
                class="font-weight-bold"
              />
            </v-row>
          </template>
        </v-img>
        <v-row align="end" justify="end" class="mt-2 mr-1">
          <v-btn
            color="primary"
            class="font-weight-bold"
            v-if="checkStatusAvatar"
            @click="handleApprove('avatar')"
            >承認</v-btn
          >
          <v-btn
            color="error"
            class="ml-3 font-weight-bold"
            v-if="checkStatusAvatar"
            @click="handleReject('avatar')"
            >拒否</v-btn
          >
        </v-row>

        <strong>{{ $t("pr-video-title") }}</strong>
        <video
          id="videoDuration"
          width="300"
          controls
          v-if="
            (checkStatusVideoPr &&
              profileTeacher.infoConfirm &&
              profileTeacher.infoConfirm.video_pr) ||
            profileTeacher.video_pr
          "
        >
          <source
            :src="
              checkStatusVideoPr
                ? profileTeacher.infoConfirm.video_pr.data
                : profileTeacher.video_pr
            "
          />
        </video>
        <v-img
          v-else
          :src="videoNotFound"
          max-height="300px"
          max-width="300px"
          width="300px"
          aspect-ratio="1.4"
        >
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular
                indeterminate
                color="primary"
                class="font-weight-bold"
              />
            </v-row>
          </template>
        </v-img>
        <v-row align="end" justify="end" class="mt-2 mr-1">
          <v-btn
            color="primary"
            class="font-weight-bold"
            v-if="checkStatusVideoPr"
            @click="handleApprove('video')"
            >承認</v-btn
          >
          <v-btn
            class="ml-3 font-weight-bold"
            color="error"
            v-if="checkStatusVideoPr"
            @click="handleReject('video')"
            >拒否</v-btn
          >
        </v-row>
      </v-col>
      <v-col :offset="1">
        <!-- Country -->
        <v-row>
          <v-col class="py-0">
            <strong for="nickname">ニックネーム</strong>
            <Tooltip
              :content="
                checkStatusNickname
                  ? profileTeacher.infoConfirm.nickname.data
                  : profileTeacher.nickname
              "
              class="d-flex"
            />
          </v-col>
          <v-col class="py-0 d-flex">
            <v-spacer />
            <v-btn
              color="primary"
              class="font-weight-bold"
              v-if="checkStatusNickname"
              @click="handleApprove('nickname')"
              >承認</v-btn
            >
            <v-btn
              class="ml-3 font-weight-bold"
              color="error"
              v-if="checkStatusNickname"
              @click="handleReject('nickname')"
              >拒否</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-0">
            <strong for="firstnameEn">{{ $t("firstname-title") }}(EN)</strong>
            <Tooltip
              :content="
                checkStatusNameEN
                  ? profileTeacher.infoConfirm.name_en.data.first_name
                  : profileTeacher.first_name_en
              "
              maxW="300px"
              class="d-flex"
            />
          </v-col>
          <v-col class="py-0">
            <strong for="lastnameEn">{{ $t("lastname-title") }}(EN)</strong>
            <Tooltip
              :content="
                checkStatusNameEN
                  ? profileTeacher.infoConfirm.name_en.data.last_name
                  : profileTeacher.last_name_en
              "
              maxW="300px"
              class="d-flex"
            />
          </v-col>
          <v-col class="py-0 d-flex">
            <v-spacer />
            <v-btn
              color="primary"
              class="font-weight-bold"
              v-if="checkStatusNameEN"
              @click="handleApprove('nameEN')"
              >承認</v-btn
            >
            <v-btn
              class="ml-3 font-weight-bold"
              color="error"
              v-if="checkStatusNameEN"
              @click="handleReject('nameEN')"
              >拒否</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-0">
            <strong for="firstnameJa">{{ $t("firstname-title") }}(JA)</strong>
            <Tooltip
              :content="
                checkStatusNameJA
                  ? profileTeacher.infoConfirm.name_jp.data.first_name
                  : profileTeacher.first_name_jp
              "
              maxW="300px"
              class="d-flex"
            />
          </v-col>
          <v-col class="py-0">
            <strong for="lastnameJa">{{ $t("lastname-title") }}(JA)</strong>
            <Tooltip
              :content="
                checkStatusNameJA
                  ? profileTeacher.infoConfirm.name_jp.data.last_name
                  : profileTeacher.last_name_jp
              "
              maxW="300px"
              class="d-flex"
            />
          </v-col>
          <v-col class="py-0 d-flex">
            <v-spacer />
            <v-btn
              color="primary"
              class="font-weight-bold"
              v-if="checkStatusNameJA"
              @click="handleApprove('nameJA')"
              >承認</v-btn
            >
            <v-btn
              class="ml-3 font-weight-bold"
              color="error"
              v-if="checkStatusNameJA"
              @click="handleReject('nameJA')"
              >拒否</v-btn
            >
          </v-col>
        </v-row>
        <!-- Email -->
        <!-- <v-row>
          <v-col class="py-0">
            <strong for="email">{{ $t("email-title") }}</strong>
            <Tooltip
              :content="profileTeacher.email"
              maxW="600px"
              class="d-flex"
            />
          </v-col>
        </v-row> -->
        <!-- Country -->
        <v-row>
          <v-col class="py-0">
            <strong for="country">{{ $t("language-title") }}</strong>
            <Tooltip :content="languageTeacher" maxW="600px" class="d-flex" />
          </v-col>
        </v-row>
        <!-- Experience -->
        <v-row>
          <v-col class="py-0">
            <strong for="experience">{{ $t("experience-title") }}</strong>
            <v-row class="px-3">
              <p>
                {{
                  `${profileTeacher.year_exp} 年 ${profileTeacher.month_exp}ヵ月`
                }}
              </p>
            </v-row>
          </v-col>
          <!-- Teach level -->
        </v-row>
        <v-row>
          <v-col class="py-0">
            <strong for="teachLevel">教えられるレベル</strong>
            <p class="mb-0" v-for="level in levelTeacher" :key="level">{{ level }}</p>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="py-0">
            <strong>{{ $t("pr-content-title") }}</strong>

            <div class="multiline">
              {{
                checkStatusSentencePr
                  ? profileTeacher.infoConfirm.sentence_pr.data
                  : profileTeacher.sentence_pr
              }}
            </div>
          </v-col>
          <v-col class="py-0 d-flex max-width-2">
            <v-spacer />
            <v-btn
              color="primary"
              class="font-weight-bold"
              v-if="checkStatusSentencePr"
              @click="handleApprove('sentencePR')"
              >承認</v-btn
            >
            <v-btn
              class="ml-3 font-weight-bold"
              color="error"
              v-if="checkStatusSentencePr"
              @click="handleReject('sentencePR')"
              >拒否</v-btn
            >
          </v-col>
        </v-row>
        <v-row class="mt-2">
          <v-col class="py-0">
            <strong>{{ $t("good-at-topic-s-title") }}</strong>
            <div>
              <template v-for="topic in topicShow">
                <v-chip
                  small
                  :key="topic"
                  v-if="topicShow"
                  color="primary"
                  class="mr-3 font-weight-medium"
                  style="min-width: 94px; justify-content: center"
                >
                  {{ topic }}
                </v-chip>
              </template>
            </div>
          </v-col>
          <v-col class="py-0 d-flex max-width-2">
            <v-spacer />
            <v-btn
              color="primary"
              class="font-weight-bold"
              v-if="checkStatusTopicPr"
              @click="handleApprove('topic')"
              >承認</v-btn
            >
            <v-btn
              class="ml-3 font-weight-bold"
              color="error"
              v-if="checkStatusTopicPr"
              @click="handleReject('topic')"
              >拒否</v-btn
            >
          </v-col>
        </v-row>
      </v-col>
      <!-- dialog confirm ban user  -->
      <v-dialog
        v-model="dialogConfirm"
        :width="typeAction == 'Approve' ? '330' : '380'"
      >
        <v-card>
          <v-card-title class="headline grey lighten-2 py-2">確認</v-card-title>

          <v-card-text class="mt-2">{{ contentConfirm }}</v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color @click="dialogConfirm = false">キャンセル</v-btn>
            <v-btn color="success" :loading="loadding" @click="handleConfirmOK"
              >OK</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row no-gutters justify="end" class="mt-4">
      <v-btn @click="goBack">戻る</v-btn>
    </v-row>
  </div>
</template>

<script>
import mixin from "@/mixin";
import imageNotFound from "@/assets/image-not-found.png";
import videoNotFound from "@/assets/video-not-found.png";
import {
  getProfileTeacher,
  approveTeacher,
  rejectTeacher,
} from "@/api/Teacher.api";
import Tooltip from "@/components/Tooltip/Tooltip";
import countries from "@/statics/countries.json";
export default {
  mixins: [mixin.Auth],
  components: {
    Tooltip,
  },
  data() {
    return {
      profileTeacher: {},
      imageNotFound,
      videoNotFound,
      typeConfirm: "",
      dialogConfirm: false,
      typeAction: "",
      loadding: false,
      contentConfirm: "",
      teachLevel: [
        { text: "入門", value: "introduction" },
        { text: "初級", value: "beginner" },
        { text: "中級", value: "intermediate" },
        { text: "上級", value: "advanced" },
        { text: "超級", value: "super" },
        { text: "ビジネス", value: "business" },
      ],
    };
  },
  async created() {
    await this.handleGetProfileTeacher();
    console.log("profileTeacher: ", this.profileTeacher);
  },
  computed: {
    checkStatusAvatar() {
      const { infoConfirm } = this.profileTeacher;
      if (
        infoConfirm &&
        infoConfirm.avatar &&
        infoConfirm.avatar.status !== "REJECT"
      ) {
        return true;
      }
      return false;
    },
    checkStatusSentencePr() {
      const { infoConfirm } = this.profileTeacher;
      if (
        infoConfirm &&
        infoConfirm.sentence_pr &&
        infoConfirm.sentence_pr.status !== "REJECT"
      ) {
        return true;
      }
      return false;
    },
    checkStatusVideoPr() {
      const { infoConfirm } = this.profileTeacher;
      if (
        infoConfirm &&
        infoConfirm.video_pr &&
        infoConfirm.video_pr.status !== "REJECT"
      ) {
        return true;
      }
      return false;
    },
    checkStatusNameEN() {
      const { infoConfirm } = this.profileTeacher;
      if (
        infoConfirm &&
        infoConfirm.name_en &&
        infoConfirm.name_en.status !== "REJECT"
      ) {
        return true;
      }
      return false;
    },

    checkStatusNameJA() {
      const { infoConfirm } = this.profileTeacher;
      if (
        infoConfirm &&
        infoConfirm.name_jp &&
        infoConfirm.name_jp.status !== "REJECT"
      ) {
        return true;
      }
      return false;
    },
    checkStatusTopicPr() {
      const { infoConfirm } = this.profileTeacher;
      if (
        infoConfirm &&
        infoConfirm.topic_pr &&
        infoConfirm.topic_pr.status !== "REJECT"
      ) {
        return true;
      }
      return false;
    },
    checkStatusNickname() {
      const { infoConfirm } = this.profileTeacher;
      if (
        infoConfirm &&
        infoConfirm.nickname &&
        infoConfirm.nickname.status !== "REJECT"
      ) {
        return true;
      }
      return false;
    },
    topicShow() {
      const { profileTeacher, checkStatusTopicPr } = this;
      if (checkStatusTopicPr) {
        return profileTeacher.infoConfirm.topic_pr.data;
      }
      return profileTeacher.topic_pr;
    },
    languageTeacher() {
      const {
        _,
        profileTeacher: { language },
      } = this;
      if (language) {
        return _.find(countries, function (o) {
          return o.code == language;
        }).name;
      }
      return "";
    },
    levelTeacher() {
      const {
        _,
        profileTeacher: { level },
        teachLevel,
      } = this;
      if(typeof level == "string" && level.length > 0){
        let fin = _.find(teachLevel, function (i) {
            return i.value == level;
          }).text;
        return [fin]
      }
      if (level && level.length > 0) {
        let listLevel = [];
        _.forEach(level, function (o) {
          console.log("o: ",o)
          let fin = _.find(teachLevel, function (i) {
            return i.value == o;
          });
          console.log("fin: ",fin)
          if (fin) {
            listLevel.push(fin.text);
          }
        });
        return listLevel;
      }
      return [];
    },
  },
  methods: {
    async handleGetProfileTeacher() {
      console.log("this.$router: ", this.$route);
      const { id, username } = this.$route.params;
      let params = {
        teacher_id: id,
        username,
      };
      await getProfileTeacher(params).then((res) => {
        this.profileTeacher = res.result;
      });
    },
    goBack() {
      this.$router.push({ name: "List Teacher" });
    },
    async handleConfirmOK() {
      const { id, username } = this.$route.params;
      const {
        avatar,
        name_en,
        name_jp,
        video_pr,
        sentence_pr,
        topic_pr,
        nickname,
      } = this.profileTeacher.infoConfirm;
      const { typeConfirm, typeAction } = this;
      let params = {
        teacher_id: id,
        username,
      };
      this.loadding = true;
      if (typeConfirm == "avatar") {
        params.id = avatar.Id;
      } else if (typeConfirm == "nameEN") {
        params.id = name_en.Id;
      } else if (typeConfirm == "nameJA") {
        params.id = name_jp.Id;
      } else if (typeConfirm == "video") {
        params.id = video_pr.Id;
      } else if (typeConfirm == "sentencePR") {
        params.id = sentence_pr.Id;
      } else if (typeConfirm == "topic") {
        params.id = topic_pr.Id;
      } else if (typeConfirm == "nickname") {
        params.id = nickname.Id;
      }
      if (typeAction == "Approve") {
        await approveTeacher(params)
          .then(() => {
            this.dialogConfirm = false;
            this.handleGetProfileTeacher();
          })
          .catch((err) => this.$toast.error(err));
      } else if (typeAction == "Reject") {
        await rejectTeacher(params)
          .then(() => {
            this.dialogConfirm = false;
            this.handleGetProfileTeacher();
          })
          .catch((err) => this.$toast.error(err));
      }

      this.loadding = false;
    },
    handleApprove(type) {
      if (type == "avatar") {
        this.contentConfirm = "アバターを承認してもよろしいですか？";
      } else if (type == "nameEN") {
        this.contentConfirm = "先生名(EN)を承認してもよろしいですか？";
      } else if (type == "nameJA") {
        this.contentConfirm = "先生名(JA)を承認してもよろしいですか？";
      } else if (type == "video") {
        this.contentConfirm = "動画PRを承認してもよろしいですか？";
      } else if (type == "sentencePR") {
        this.contentConfirm = "先生PRを承認してもよろしいですか？";
      } else if (type == "topic") {
        this.contentConfirm = "得意な話題を承認してもよろしいですか？";
      } else if (type == "nickname") {
        this.contentConfirm = "ニックネームを承認してもよろしいですか？";
      }
      this.typeAction = "Approve";
      this.typeConfirm = type;
      this.dialogConfirm = true;
    },
    handleReject(type) {
      if (type == "avatar") {
        this.contentConfirm = "アバターの承認を拒否してもよろしいですか？";
      } else if (type == "nameEN") {
        this.contentConfirm = "先生名(EN)の承認を拒否してもよろしいですか？";
      } else if (type == "nameJA") {
        this.contentConfirm = "先生名(JA)の承認を拒否してもよろしいですか？";
      } else if (type == "video") {
        this.contentConfirm = "動画PRの承認を拒否してもよろしいですか？";
      } else if (type == "sentencePR") {
        this.contentConfirm = "先生PRの承認を拒否してもよろしいですか？";
      } else if (type == "topic") {
        this.contentConfirm = "得意な話題の承認を拒否してもよろしいですか？";
      } else if (type == "nickname") {
        this.contentConfirm = "ニックネームの承認を拒否してもよろしいですか？";
      }
      this.typeAction = "Reject";
      this.typeConfirm = type;
      this.dialogConfirm = true;
    },
  },
};
</script>

<style lang="scss" scoped>
tr td:first-child {
  border-right: 1px solid #ccc;
}
.multiline {
  font-family: inherit;
  font-family: inherit;
  white-space: pre-line;
  word-break: break-word;
}
</style>